import React from "react";
import "./LoadingIndicator.css";

export default function LoadingIndicator({ children = "Loading...", announce = true }) {
  return <span className="app-loading-indicator" role={announce ? "status" : undefined} aria-live={announce ? "polite" : undefined}>
    <span className="spinner-border spinner-border-sm app-loading-spinner" aria-hidden="true" />
    <span>{children}</span>
  </span>;
}
